module.exports = __webpack_public_path__ + "img/about_inner2.23513629.png";